export default __webpack_public_path__ + "media/images/about/video-poster.jpg";